import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Pages/Home";
import Login from "./components/Login/Login";
import FormProducts from "./components/FormProducts/FormProducts";
import Ferreteria from "./components/Pages/Ferreteria";
import ProteccionPersonal from "./components/Pages/ProteccionPersonal";
import Construccion from "./components/Pages/Construccion";
import Refacciones from "./components/Pages/Refacciones";
import { useDispatch, useSelector } from "react-redux";
import EditProduct from "./components/Products/EditProduct";



function App() {
    const dispatch = useDispatch();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    
   

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
        if (storedIsLoggedIn === "true") {
            setIsLoggedIn(true);
        }
    }, []);
  

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />

                <Route path="/ferreteria" element={<Ferreteria />} />
                <Route path="/proteccion" element={<ProteccionPersonal />} />
                <Route path="/construccion" element={<Construccion />} />
                <Route path="/refacciones" element={<Refacciones />} />
                <Route path="/login" element={<Login />} />
                {typeof isLoggedIn === "boolean" && isLoggedIn ? (
        <Route path="/formProducts" element={<FormProducts />} />
      ) : (
        <Route path="/" element={<Home />} />
      )}
      {typeof isLoggedIn === "boolean" && isLoggedIn ? (
      <Route path="/products/:id" element={<EditProduct />} />
      ) : (
        <Route path="/" element={<Home />} />
      )}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
